import { render } from "./Tab1Page.vue?vue&type=template&id=2c9d2a92"
import script from "./Tab1Page.vue?vue&type=script&lang=js"
export * from "./Tab1Page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__